// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React from 'react';
import cx from 'classnames';
import get from 'lodash/get';
import {BlockControls} from '../block-controls';
import {Dissatisfied} from '@app/../static/assets/icons/dissatisfied';
import {Neutral} from '@app/../static/assets/icons/neutral';
import {Satisfied} from '@app/../static/assets/icons/satisfied';

/* Creates a mock of the widget block for the
 * Customer Satisfaction Scale (CSAT) to expose the
 * CXCreationModal data.
 */
export const renderInactiveCSATBlock = (input) => {
    const csatBlock = get(input, ['cx_question_block']);
    const blockClassname = cx(
        'kare-block kare-block--inactive kare-block-csat',
    );
    const iconSize = 60;
    return (
        <section className={blockClassname}>
            <h1>{csatBlock.question}</h1>
            <section className="csat-container">
                <div className="csat-item">
                    <div className="csat-icon-wrapper danger">
                        <Dissatisfied size={iconSize} />
                    </div>
                    <div className="csat-text-wrapper">
                        <span>{csatBlock.label_negative}</span>
                    </div>
                </div>
                <div className="csat-item">
                    <div className="csat-icon-wrapper warning">
                        <Neutral size={iconSize} />
                    </div>
                    <div className="csat-text-wrapper">
                        <span>{csatBlock.label_neutral}</span>
                    </div>
                </div>
                <div className="csat-item">
                    <div className="csat-icon-wrapper success">
                        <Satisfied size={iconSize} />
                    </div>
                    <div className="csat-text-wrapper">
                        <span>{csatBlock.label_positive}</span>
                    </div>
                </div>
            </section>
        </section>
    );
};

interface CSATBlockFieldProps {
    index?: number;
    fields?: any;
    removeBlock?: any;
    activateBlock?: any;
    input?: any;
}

export const CSATBlockField = (props: CSATBlockFieldProps) => {
    const {index, fields, removeBlock, activateBlock, input} = props;
    const block = get(input, ['value']);
    return (
        <div className="csat kare-cx-block-wrapper">
            {renderInactiveCSATBlock(block)}
            {index >= 0 && fields && removeBlock && (
                <BlockControls
                    index={index}
                    fields={fields}
                    removeBlock={removeBlock}
                    activateBlock={activateBlock}
                />
            )}
        </div>
    );
};
